import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import URL from "../../constant/URL";
import AnsweringQuestionsInitializer from "../answeringQuestions/learning/container/AnsweringQuestionsInitializer";
import AnsweringQuestions from "../answeringQuestions/learning/presentational/AnsweringQuestions";
// import Result from "./result/Result";
import CheckWrongAnswer from "./checkWrongAnswer/CheckWrongAnswer";
import ReAnsweringInitializer from "../answeringQuestions/reAnswering/container/AnsweringQuestionsInitializer";
import ReAnswering from "../answeringQuestions/reAnswering/presentational/AnsweringQuestions";
import ResultV2 from "./result/ResultV2";

const Learning = () => {

  const routeMatch = useRouteMatch();

  return <Route path={ `${ routeMatch.url }/:depth3` }><Children /></Route>;

};

const Children = () => {

  return (

    <Switch>
      <Route path={ `${ URL.LEARNING.ANSWERING_QUESTIONS }/:learningType/:stageCode` }><AnsweringQuestionsInitializer><AnsweringQuestions /></AnsweringQuestionsInitializer></Route>
      {/* <Route path={ URL.LEARNING.RESULT }><Result /></Route> */}
      <Route path={ URL.LEARNING.CHECK_WRONG_ANSWER }><CheckWrongAnswer /></Route>
      <Route path={ URL.LEARNING.RE_ANSWERING }><ReAnsweringInitializer><ReAnswering /></ReAnsweringInitializer></Route>
      <Route path={ URL.LEARNING.RESULT }><ResultV2 /></Route>
    </Switch>

  );

};

export default Learning;
